import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	flagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	flagTitle: {
		id: 'issue-navigator-actions-common.error-flag.flag-title',
		defaultMessage: "Filter couldn't be saved",
		description: 'Title for the flag shown when filter could not be saved',
	},
});
export default messages;
